import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderService } from '../shared/loader.service';
import { HttpClient, HttpClientModule } from '@angular/common/http'; // ✅ Add
import { environment } from '../../environments/environment';        // ✅ Add

@Component({
  standalone: true,
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  /*imports: [CommonModule, RouterModule, HeaderComponent, SidebarComponent],*/
  imports: [CommonModule, RouterModule, HeaderComponent, SidebarComponent, HttpClientModule],
})
export class LayoutComponent implements OnInit {
  componentName: string = 'Not Set';

  isLoading: boolean = false; // Default to true to show loader on initial load
  isLoading$ = this.loader.loading$;
  progress$ = this.loader.progress$;

  private baseUrl = environment.apiBaseUrl;       // ✅ Add
  private apiversion = environment.apiversion;    // ✅ Add

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private http: HttpClient   // ✅ Add
  ) { }

  ngOnInit() {
    // ✅ Set title on first load
    this.setComponentTitle(this.route);

    // ✅ Update title on every route change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setComponentTitle(this.route);
      });
  }

  private setComponentTitle(route: ActivatedRoute) {
    let currentRoute = route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const title = currentRoute.snapshot.data['title'] || '';

    if (title === 'Monthly Forecast') {
      this.componentName = 'Monthly Forecast';
      this.fetchForecastMonthYear();  // ✅ dynamic fetch
    } else {
      this.componentName = title;
    }
  }

  // ✅ New method
  private fetchForecastMonthYear(): void {
    const base = this.baseUrl.replace(/\/+$/g, '');
    const apiBase = base.endsWith('/api') ? base : `${base}/api`;
    const url = `${apiBase}/forecast/date?api-version=${this.apiversion}`;

    this.http.get<any>(url).subscribe({
      next: (res) => {
        if (res?.success && res?.result?.startDate) {
          const startDate = new Date(res.result.startDate);

          // ✅ Next month calculate karo
          const nextMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);

          const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
          this.componentName = `Monthly Forecast - ${monthNames[nextMonth.getMonth()]}/${nextMonth.getFullYear()}`;
        }
      },
      error: () => {
        this.componentName = 'Monthly Forecast';
      }
    });
  }
}
